
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Box,
  Grid,
} from "@mui/material";

import {


  TableContainer,
  TableHead,

  Typography,
} from "@mui/material";



import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({
  totals, summary
}) {


  //console.log("totals", totals);


  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >
      <TableContainer>
      <Table size="small">
        <TableBody>
          <TableRow
            sx={{
              bgcolor: "success.light",
              "& td": {
                fontWeight: 700,
                fontSize: 15,
              },
            }}
          >
            <TableCell>
              GRAND TOTAL
            </TableCell>

             <TableCell align="right">
                        <CurrencyCell
                          value={totals.highlyskilledtime}
                        />
                      </TableCell>
            
                      <TableCell align="right">
                        <CurrencyCell
                          value={totals.highlyskilledcost}
                        />
                      </TableCell>
            
                      <TableCell align="right">
                        <CurrencyCell
                          value={totals.skilledtime}
                        />
                      </TableCell>
            
                      <TableCell align="right">
                        <CurrencyCell
                          value={totals.skilledcost}
                        />
                      </TableCell>
            
                      <TableCell align="right">
                        <CurrencyCell
                          value={totals.semiskilledtime}
                        />
                      </TableCell>
            
                      <TableCell align="right">
                        <CurrencyCell
                          value={totals.semiskilledcost}
                        />
                      </TableCell>
            
                      <TableCell align="right">
                        <CurrencyCell
                          value={totals.unskilledtime}
                        />
                      </TableCell>
            
                      <TableCell align="right">
                        <CurrencyCell
                          value={totals.unskilledcost}
                        />
                      </TableCell>
            
                      <TableCell align="right">
                        <CurrencyCell
                          value={totals.oncostlabour}
                        />
            
                        </TableCell>
            
            
                       <TableCell align="right">
                        <CurrencyCell
                          value={totals.oncoststore}
                        />
                        
                      </TableCell>
            
          </TableRow>
        </TableBody>
      </Table>

</TableContainer>



      <Grid
        container
        spacing={0}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ mb: 20, px: 2 }}
      >
        <Grid size={{ xs: 12, md: 4 }}>

          {/* <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ mt: 3, maxWidth: 450 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    STORE DATA SUMMARY
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>


                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      DIRECT STORE
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Prime Cost Stores + DS8 + M-DR − MIN DS8
                    </Typography>
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={summary.directStore} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      RETURNED STORE (DRR)
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      DS8 − MIN DS8
                    </Typography>
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={summary.returnedStore} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      ON COST STORE
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={totals.onCostStores} />
                  </TableCell>
                </TableRow>


                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer> */}


        </Grid>

        <Grid size={{ xs: 12, md: 4 }} >

          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ mt: 3, maxWidth: 550 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    Labour Sub Sheet SUMMARY
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <TableCell><b>Total Labour on Cost (Distributed OC Labour)</b></TableCell>
                  <TableCell align="right">
                    <CurrencyCell value={totals.oncostlabour} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell><b>Total Store on Cost (Distributed OC Store)</b></TableCell>
                  <TableCell align="right">
                    <CurrencyCell value={totals.oncoststore}/>
                  </TableCell>
                </TableRow>

                 <TableRow>
                  <TableCell></TableCell>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>

                <TableRow>
                  <TableCell><b>Grand Total Labour Cost</b></TableCell>
                  <TableCell align="right">
                    <CurrencyCell value={totals.highlyskilledcost + totals.skilledcost + totals.unskilledcost + totals.semiskilledcost}  />
                  </TableCell>
                </TableRow>
            
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>


              </TableBody>
            </Table>
          </TableContainer>

        </Grid>



        <Grid size={{ xs: 12, md: 4 }} >

          {/* <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ mt: 3, maxWidth: 450 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    LABOUR DATA SUMMARY
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>


 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                     DIRECT LABOUR
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={totals.primeLabour} />
                  </TableCell>
                </TableRow>


                 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      ON COST LABOUR
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={totals.onCostLabour} />
                  </TableCell>
                </TableRow>



                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>


              </TableBody>
            </Table>
          </TableContainer> */}

        </Grid>



      </Grid>

    </Paper>
  );
}

